<template>
  <div class="analytics-layout h-screen flex flex-col">
    <Header 
      title="Analytics" 
      :showMenuToggle="true" 
      @toggle-sidebar="toggleSidebar"
    />
    
    <div class="flex flex-1 overflow-hidden">
      <!-- Main Content -->
      <main 
        class="flex-1 overflow-auto bg-gray-100 dark:bg-gray-800 p-6"
      >
        <div class="mb-6">
          <h2 class="text-2xl font-bold text-gray-800 mb-6">Property Analytics</h2>
          
          <!-- Analytics Component -->
          <Analytics />
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Header from '../components/Header.vue';
import Sidebar from '../components/Sidebar.vue';
import Analytics from '../components/Analytics.vue';
import { usePropertiesStore } from '../stores/properties';

const propertiesStore = usePropertiesStore();
const sidebarCollapsed = ref(false);

const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value;
};

// Fetch properties on component mount
onMounted(async () => {
  await propertiesStore.fetchProperties();
});
</script>
